<template>
  <div style="transition: width 0.2s;" class="text-primary overflow-x-hidden overflow-y-auto scrollbar-thin scrollbar-thumb-primary scrollbar-track-secondary" :class="{'w-16': collapsed, 'w-60': !collapsed, 'hidden-menu': collapsed, 'shadow_box': collapse, 'hidden-menu-end': linkJustifyCenter}">
    <div class="w-full flex" :class="{'ml-2': !linkJustifyCenter, 'justify-center': linkJustifyCenter}" v-if="collapse">
      <svg class="mb-6 w-6 h-6 fill-primary cursor-pointer" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" @click.prevent="collapsedMenu = !collapsedMenu;"><path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" /></svg>
    </div>
    <div v-if="user.photo?.url || !collapsed" class="mt-1 mb-4 grid grid-flow-col auto-cols-max overflow-hidden" :class="{'justify-center': !user.photo?.url}">
      <div v-if="user.photo?.url" class="ml-2 mr-2 w-6">
        <img :src="user.photo.url" class="rounded-full w-full" />
      </div>
      <div v-if="!collapsed" class="whitespace-nowrap">
        {{ username }}
      </div>
    </div>
    <main-menu-item v-if="user.role == 1" label="Dashboard" icon="fa-chart-column" link="/dashboard" :selected="isUrl('dashboard') ? true : false" />
    <main-menu-item v-if="user.role == 2" label="Home" icon="fa-chart-column" link="/home" :selected="isUrl('home') ? true : false" />
    <main-menu-item v-if="user.role == 2" label="Agenda" icon="fa-calendar-day" link="/schedules" :selected="isUrl('schedules') ? true : false" />
    <main-menu-item v-if="user.role == 1" label="Gestão de profissionais" icon="fa-stethoscope" link="/professionals" :selected="isUrl('professionals') ? true : false" />
    <main-menu-item v-if="user.role == 1" label="Dashboard profissional" icon="fa-laptop-medical" link="/professionals-dashboard" :selected="isUrl('professionals-dashboard') ? true : false" />
    <main-menu-item :label="user.role == 1 ? 'Gestão de pacientes' : 'Pacientes'" icon="fa-hospital-user" link="/patients" :selected="isUrl('patients') ? true : false" />
    <main-menu-item v-if="user.role == 2" label="Pagamentos" :afterIcon="user.professional?.wallet?.confirmed === false ? 'fa-exclamation' : ''" icon="fa-dollar-sign" link="/payments" :selected="isUrl('payments') ? true : false" />
    <main-menu-item v-if="user.role == 1" label="Histórico de consultas" icon="fa-notes-medical" link="/appointments-history" :selected="isUrl('appointments-history') ? true : false" />
    <main-menu-item v-if="user.role == 1" label="Notificações" icon="fa-bell" link="/scheduled-notifications" :selected="isUrl('scheduled-notifications') ? true : false" />
    <main-menu-item v-if="user.role == 1" label="Especialidades" icon="fa-suitcase-medical" link="/specialties" :selected="isUrl('specialties') ? true : false" />
    <main-menu-item v-if="user.role == 1" label="Dados Vitais" icon="fa-file-medical" link="/vital-data" :selected="isUrl('vital-data') ? true : false" />
    <main-menu-item v-if="user.role == 1" label="Empresas" icon="fa-building" link="/companies" :selected="isUrl('companies') ? true : false" />
    <main-menu-item label="Termos de uso" icon="fa-circle-info" link="/terms" :selected="isUrl('terms') ? true : false" />
    <main-menu-item v-if="user.role == 1" label="Configurações" icon="fa-cog" link="/config" :selected="isUrl('config') ? true : false" />
    <main-menu-item v-if="user.role == 1" label="Configurar Atendimentos B2B" icon="fa-notes-medical" link="/seetings-services-b2b" :selected="isUrl('seetings-services-b2b') ? true : false" />
    <main-menu-item v-if="user.role == 2" label="Suporte" icon="fa-headset" @click.prevent="openModalSupport()" />
    <main-menu-item label="Perfil" icon="fa-user" link="/profile" :selected="isUrl('profile') ? true : false" />
    <main-menu-item label="Sair" icon="fa-right-from-bracket" @click.prevent="openModalLogout()" />
  </div>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3'
import MainMenuItem from '@/Shared/Layout/MainMenuItem'
import { computed } from 'vue'
import { usePage } from '@inertiajs/inertia-vue3'

export default {
  inject: ['openModalLogout', 'openModalSupport'],
  components: {
    MainMenuItem,
    Link,
  },
  props: {
    collapse:  {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      collapsedMenu: false,
      linkJustifyCenter: false,
    }
  },
  computed: {
    collapsed: function () {
      return this.collapse && this.collapsedMenu;
    },
    username: function () {
      const splitedUserName = this.user.name.split( ' ' )
      return splitedUserName.map( ( name, index ) => index > 0 && index < splitedUserName.length - 1 ? `${ name.charAt( 0 ) }.` : name ).join( ' ' )
    },
  },
  watch: {
    collapsedMenu(newValue) {
      localStorage.collapsedMenu = newValue;
      setTimeout(function() {
        this.linkJustifyCenter = this.collapsedMenu;
      }, 200);
    }
  },
  mounted() {
    if (typeof(localStorage.collapsedMenu) == "string") {
      this.collapsedMenu = JSON.parse(localStorage.collapsedMenu) === true;
    }
  },
  methods: {
    collapseMenu() {
      this.collapsedMenu = true;
    },
    openMenu() {
      this.collapsedMenu = false;
    },
    isUrl(...urls) {
      let currentUrl = this.$page.url.substr(1)
      if (urls[0] === '') {
        return currentUrl === ''
      }
      return urls.filter((url) => currentUrl === url || currentUrl.startsWith(url + '/')).length
    },
  },
  setup() {
    const user = computed(() => usePage().props.value.auth.user)
    return { user }
  },
}
</script>
<style>
  .hidden-menu-end a,
  .hidden-menu-end button {
    @apply px-0 justify-center;
  }
  .hidden-menu a span,
  .hidden-menu a .afterIcon,
  .hidden-menu button span,
  .hidden-menu button .afterIcon {
    display: none;
  }
  .hidden-menu a svg,
  .hidden-menu button svg {
    @apply mr-0;
  }
</style>
